import { render } from "./DataSlideOverBank.vue?vue&type=template&id=5f204a26&ts=true"
import script from "./DataSlideOverBank.vue?vue&type=script&lang=ts"
export * from "./DataSlideOverBank.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__